import { Box, Typography } from "@mui/material";
import Image from "next/image";
import indianFlag from "../../assets/india-flag.png";
import ukFlag from "../../assets/uk-flag.png";
import { FC } from "react";

interface LanguageButtonProps {
  selected: boolean;
  setSelected: (value: boolean) => void;
}

const LanguageButton: FC<LanguageButtonProps> = ({ selected, setSelected }) => {
  const handleToggle = () => {
    setSelected(!selected);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: selected ? "flex-start" : "flex-end",
        width: "110px",
        height: "40px",
        background: "rgba(223, 246, 232, 0.95)",
        border: "1px solid rgba(18, 53, 36, 0.15)",
        borderRadius: "25px",
        padding: "5px",
        cursor: "pointer",
        position: "fixed",
        top: { xs: "calc(72px + env(safe-area-inset-top, 0px))", sm: "100px" },
        right: { xs: 12, sm: 16 },
        transition: "all 0.3s ease-in-out",
        zIndex: 1000,
        boxShadow: "0 8px 24px rgba(18, 53, 36, 0.12)",
      }}
      onClick={handleToggle}
    >
      {/* Text */}
      <Typography
        sx={{
          position: "absolute",
          left: selected ? "50px" : "auto",
          right: selected ? "auto" : "60px",
          fontWeight: "bold",
          color: "#123524",
          fontSize: "13px",
          transition: "all 0.3s ease-in-out",
          textTransform: "capitalize",
        }}
      >
        {selected ? "English" : "हिन्दी"}
      </Typography>

      {/* Toggle Button */}
      <Box
        sx={{
          width: "32px",
          height: "32px",
          background: "#e0e0e0",
          borderRadius: "50%",
          boxShadow: "0px 0px 0px #bcbcbc, 0px 0px 2px #000",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.3s ease-in-out",
        }}
      >
        {selected ? (
          <Image
            height={50}
            width={50}
            src={ukFlag}
            alt="flag"
            style={{
              height: "100%",
              objectFit: "cover",
              borderRadius: "50%",
            }}
          />
        ) : (
          <Image
            height={50}
            width={50}
            src={indianFlag}
            alt="flag"
            style={{
              height: "100%",
              objectFit: "cover",
              borderRadius: "50%",
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default LanguageButton;
